import React, { useCallback, useEffect, useState } from "react";
import { Button, Input, Select, DatePicker, Tooltip } from "antd";
import { httpService } from "../../../../../services/httpService.service";
import dayjs from "dayjs";
import SearchIcon from "./../../../../../Assets/svg/searchIcon.svg";
import debounce from "lodash/debounce";
import { InfoCircleOutlined } from "@ant-design/icons";
const { Option } = Select;

const months = [
  {
    id: 1,
    name: "January",
  },
  {
    id: 2,
    name: "February",
  },
  {
    id: 3,
    name: "March",
  },
  {
    id: 4,
    name: "April",
  },
  {
    id: 5,
    name: "May",
  },
  {
    id: 6,
    name: "June",
  },
  {
    id: 7,
    name: "July",
  },
  {
    id: 8,
    name: "August",
  },
  {
    id: 9,
    name: "September",
  },
  {
    id: 10,
    name: "October",
  },
  {
    id: 11,
    name: "November",
  },
  {
    id: 12,
    name: "December",
  },
];

const startYear = 2024;
const endYear = 2034;
const years = Array.from(
  { length: endYear - startYear + 1 },
  (_, i) => startYear + i
);

const Filters = ({ filters, setFilters, setPagination }) => {
  const [showFilters, setShowFilters] = useState(false);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [implementingPartners, setImplementingPartners] = useState([]);
  const [sampleSizes, setSampleSizes] = useState([]);
  const [filtersValue, setFiltersValue] = useState({
    ImplementingPartnerId: [],
    State: [],
    SiteVisitStatus: [],
    FieldTeamReportingStatus: "",
    ClusterId: [],
    Month: [],
    Year: [],
    Search: "",
    Governates: [],
    Cities: [],
    DataCheckIds: [],
  });

  const debouncedHandler = useCallback(
    debounce((filter) => {
      setFilters((prevFilters) => ({ ...prevFilters, ...filter }));
      setPagination((prevPagination) => ({ ...prevPagination, current: 1 }));
    }, 1000),
    []
  );

  const handleCountryChange = (value) => {
    setFiltersValue((prevFilters) => ({
      ...prevFilters,
      State: value,
    }));
    debouncedHandler({ State: value });
  };

  const handleStateChange = (value) => {
    setFiltersValue((prevFilters) => ({
      ...prevFilters,
      Governates: value,
    }));
    debouncedHandler({ Governates: value });
  };

  const handleCityChange = (Cities) => {
    setFiltersValue((prevFilters) => ({
      ...prevFilters,
      Cities: Cities,
    }));
    debouncedHandler({ Cities: Cities });
  };

  useEffect(() => {
    httpService.get(
      `/api/Site/getCountriesOfSiteVisits`,
      (res) => {
        const data = res.data;
        const uniqueCountries = new Set();

        const formattedData = data
          .map((country) => country.trim()) // Trim first
          .filter((country) => {
            if (
              country === "string" ||
              country === "undefined" ||
              country === ""
            )
              return false; // Remove invalid values

            if (uniqueCountries.has(country)) return false; // Remove duplicates

            uniqueCountries.add(country); // Add to Set before proceeding
            return true;
          })
          .map((country, index) => ({
            id: index,
            stateName: country,
          }));

        setCountries(formattedData);
      },
      (error) => {
        // console.log(error);
      }
    );

    httpService.get(
      `/api/Site/getStatesOfSiteVisits`,
      (res) => {
        const data = res.data;
        const uniqueStates = new Set();

        const formattedData = data
          .map((state) => state.trim()) // Trim first
          .filter((state) => {
            if (state === "string" || state === "undefined" || state === "")
              return false; // Remove invalid values

            if (uniqueStates.has(state)) return false; // Remove duplicates

            uniqueStates.add(state); // Add to Set before proceeding
            return true;
          })
          .map((state, index) => ({
            id: index,
            stateName: state,
          }));

        setStates(formattedData);
      },
      (error) => {
        console.log(error);
      }
    );

    httpService.get(
      `/api/Site/getCitiesOfSiteVisits`,
      (res) => {
        const data = res.data;
        const uniqueCities = new Set();

        const formattedData = data
          .map((city) => city.trim()) // Trim first
          .filter((city) => {
            if (city === "string" || city === "undefined" || city === "")
              return false; // Remove invalid values

            if (uniqueCities.has(city)) return false; // Remove duplicates

            uniqueCities.add(city); // Add to Set before proceeding
            return true;
          })
          .map((city, index) => ({
            id: index,
            name: city,
          }));

        setCities(formattedData);
      },
      (error) => {
        console.log(error);
      }
    );

    const workspaceId = localStorage.getItem("currentContractId");
    const apiIps = `/api/ImplementingPartner/getAllImplementingPartners?contractId=${workspaceId}&IgnorePagination=true`;

    httpService.get(
      apiIps,
      (res) => setImplementingPartners(res.data)
      // (error) => console.log(error)
    );

      const apiSampleSizes = `/api/Datachecks/getAll?projectId=${localStorage.getItem("currentProjectID")}`;
        httpService.get(
          apiSampleSizes,(res) => {setSampleSizes(res.data);},
          (error) => {
            // console.log(error)
          }
        );
  }, []);

  const handleToggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const handleSearch = (event) => {
    const Search = event?.target.value.toLowerCase();
    setFiltersValue((prevFilters) => ({
      ...prevFilters,
      Search: Search,
    }));
    debouncedHandler({ Search: Search });
  };

  const handleClearAll = () => {
    setFilters({
      ImplementingPartnerId: [],
      State: [],
      SiteVisitStatus: [],
      FieldTeamReportingStatus: "",
      ClusterId: [],
      Month: [],
      Year: [],
      Search: "",
      Governates: [],
      Cities: [],
      DataChecksId: [],
    });
    setFiltersValue({
      ImplementingPartnerId: [],
      State: [],
      SiteVisitStatus: [],
      FieldTeamReportingStatus: "",
      ClusterId: [],
      Month: [],
      Year: [],
      Search: "",
      Governates: [],
      Cities: [],
      DataChecksId: [],
    });
    setCities([]);
    setStates([]);
    setPagination((prevPagination) => ({ ...prevPagination, current: 1 }));
  };

  
 const handleSampleSizeChange = (sampleSize) => {
    debouncedHandler({ DataChecksId: sampleSize });
    setFiltersValue((prevFiltersValue) => ({
      ...prevFiltersValue,
      DataChecksId: sampleSize,
    }));
  };


  const handleMonthChange = (month) => {
    setFiltersValue((prevFilters) => ({
      ...prevFilters,
      Month: month,
    }));
    debouncedHandler({ Month: month });
  };

  const handleYearChange = (year) => {
    setFiltersValue((prevFilters) => ({
      ...prevFilters,
      Year: year,
    }));
    debouncedHandler({ Year: year });
  };

  return (
    <div className="filtersWrapper">
      <div className="containerFilters">
        <Input
          placeholder="Type something here"
          suffix={<img src={SearchIcon} alt="Search" />}
          onChange={handleSearch}
          value={filtersValue?.Search || undefined}
        />
        <Button className="clearButton" onClick={handleClearAll}>
          Clear All
        </Button>
        <Button onClick={handleToggleFilters} className="toggleButton">
          {showFilters ? "Hide Filters" : "Show Filters"}
        </Button>
      </div>
      {showFilters && (
        <div className="filtersContainer">
          <div className="filter">
            <p className="filterText">Implementing Partner</p>
            <Select
              mode="multiple"
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select the IP"
              allowClear
              showSearch
              value={filtersValue.ImplementingPartnerId || undefined}
              onChange={(value) => {
                setFiltersValue((prevFilters) => ({
                  ...prevFilters,
                  ImplementingPartnerId: value,
                }));
                debouncedHandler({ ImplementingPartnerId: value });
              }}
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
            >
              {implementingPartners &&
                implementingPartners.map((implementingPartner) => (
                  <Option
                    key={implementingPartner.id}
                    value={implementingPartner.id}
                  >
                    {implementingPartner.name}
                  </Option>
                ))}
            </Select>
          </div>
          <div className="filter">
            <p className="filterText">Site Visit Status</p>
            <Select
              mode="multiple"
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select a site visit status"
              allowClear
              showSearch
              value={filtersValue.SiteVisitStatus || undefined}
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
              onChange={(value) => {
                setFiltersValue((prevFilters) => ({
                  ...prevFilters,
                  SiteVisitStatus: value,
                }));
                debouncedHandler({ SiteVisitStatus: value });
              }}
            >
              <Option value={1}>No status</Option>
              <Option value={2}>Pre-planning phase</Option>
              <Option value={3}>Planning</Option>
              <Option value={4}>Data Collection</Option>
              <Option value={5}>Post data collection/Data check</Option>
              <Option value={6}>Visit completed</Option>
            </Select>
          </div>
          <div className="filter">
            <p className="filterText">Reporting status</p>
            <Select
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select a reporting status"
              allowClear
              showSearch
              value={filtersValue.FieldTeamReportingStatus || undefined}
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
              onChange={(value) => {
                setFiltersValue((prevFilters) => ({
                  ...prevFilters,
                  FieldTeamReportingStatus: value,
                }));
                debouncedHandler({ FieldTeamReportingStatus: value });
              }}
            >
              <Option value={1}>Data collection</Option>
              <Option value={2}>Data check</Option>
              <Option value={3}>Field report writing</Option>
              <Option value={4}>Translation</Option>
              <Option value={5}>Field reporting completed</Option>
              <Option value={6}>Field report approved</Option>
              <Option value={7}>Field report submitted to client</Option>
            </Select>
          </div>
          <div className="filter">
            <p className="filterText">Month</p>
            <Select
              showSearch
              allowClear
              mode="multiple"
              onChange={handleMonthChange}
              value={filtersValue.Month || undefined}
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select a month"
            >
              {months &&
                months.map((month) => (
                  <Option key={month.id} value={month.name}>
                    {month.name}
                  </Option>
                ))}
            </Select>
          </div>
          <div className="filter">
            <p className="filterText">Year</p>
            <Select
              showSearch
              mode="multiple"
              allowClear
              onChange={handleYearChange}
              value={filtersValue.Year || undefined}
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select a year"
            >
              {years &&
                years.map((year, index) => (
                  <Option key={index} value={year}>
                    {year}
                  </Option>
                ))}
            </Select>
          </div>
          <div className="filter">
            <p className="filterText">
              <Tooltip title="Countries not listed here have no scheduled site visits.">
                <InfoCircleOutlined
                  style={{ marginRight: 5, color: "#1890ff" }}
                />
              </Tooltip>
              Country
            </p>
            <Select
              onChange={handleCountryChange}
              value={filtersValue.State ? filtersValue.State : undefined}
              allowClear
              showSearch
              mode="multiple"
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select Country"
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
            >
              {countries &&
                countries.map((country) => (
                  <Option key={country.id} value={country.stateName}>
                    {country.stateName}
                  </Option>
                ))}
            </Select>
          </div>
          <div className="filter">
            <p className="filterText">
              <Tooltip title="States not listed here have no scheduled site visits.">
                <InfoCircleOutlined
                  style={{ marginRight: 5, color: "#1890ff" }}
                />
              </Tooltip>
              Governorate/State
            </p>
            <Select
              onChange={handleStateChange}
              value={
                filtersValue.Governates ? filtersValue.Governates : undefined
              }
              allowClear
              showSearch
              mode="multiple"
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select Country"
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
            >
              {states.map((state) => (
                <Option key={state.id} value={state.stateName}>
                  {state.stateName}
                </Option>
              ))}
            </Select>
          </div>
          <div className="filter">
            <p className="filterText">
              <Tooltip title="Cities not listed here have no scheduled site visits.">
                <InfoCircleOutlined
                  style={{ marginRight: 5, color: "#1890ff" }}
                />
              </Tooltip>
              City
            </p>
            <Select
              onChange={handleCityChange}
              value={filtersValue.Cities ? filtersValue.Cities : undefined}
              allowClear
              showSearch
              mode="multiple"
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select Country"
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
            >
              {cities.map((city) => (
                <Option key={city.id} value={city.name}>
                  {city.name}
                </Option>
              ))}
            </Select>
          </div>
            <div className="filter">
                      <p className="filterText">Sample Size</p>
                      <Select
                        showSearch
                        mode="multiple"
                        allowClear
                        onChange={handleSampleSizeChange}
                        value={filtersValue.DataChecksId || undefined}
                        style={{ width: 200, marginBottom: 20 }}
                        placeholder="Select a sample size"
                      >
                        {sampleSizes &&
                          sampleSizes.map((sampleSizes, index) => (
                            <Option key={index} value={sampleSizes.id}>
                              {sampleSizes.name}
                            </Option>
                          ))}
                      </Select>
                    </div>
        </div>
      )}
    </div>
  );
};

export default Filters;
